import {Box, TextField, Typography} from "@mui/material";
import { useTranslation } from "react-i18next";
import { InputFieldProps } from "../../../../common/Interfaces";
import { getInputProps, getInputLabelProps } from "../../../../common/Utils";
import styles from './InputTextField.module.scss';
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';

export default function InputDateTextField ({id,
                                            label,
                                            value,
                                            handleValueChange, 
                                            isOptional,
                                            errorMessage,
                                            width,
                                            isReadOnly}: InputFieldProps) {
                                                
    const {t} = useTranslation();

    return (<Box sx={{width: width ?? "150px"}}>
            <Box className={styles.hotizontalContainer}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                        value={value}
                        onChange={handleValueChange}
                        renderInput={(params: any) => (
                            <TextField
                                style={{width: width ?? "150px"}}
                                {...params}
                                id={id}
                                inputProps={{
                                    ...getInputProps(),
                                    placeholder: label,
                                    readOnly: isReadOnly,
                                }}
                                InputLabelProps={{
                                    ...getInputLabelProps(),
                                    style: {
                                    fontSize: '1em',
                                    width: width ?? "150px",
                                    },
                                }}
                                error={!!errorMessage}
                                value={value}
                            />
                        )}
                    />
                </LocalizationProvider>

                {isOptional && (
                    <Typography className={styles.optionalText}>
                        {`(${t("OPTIONAL")})`}
                    </Typography>
                )}
            </Box>
            
            {errorMessage && (
                <Typography className={styles.errorText}>
                    {errorMessage}
                </Typography>
            )}
        </Box>);
}